
<template>
    <div class="districts-list" :class="map_enable ? 'districts-list-map p-0' : ''">
        <div class="row">
            <div v-if="map_enable" class="col-9 p-0">
                <tecno-map-picker
                    :districts="districts_data"
                    :selected_districts="selected_districts"
                    :selected_quarters="cleanedQuarters()"
                    :config_map="config_map"
                    @select="addDistrict"
                    @deselect="removeDistrict"
                    @listHighlightOn="listHighlightOn"
                    @listHighlightOff="listHighlightOff"
                    :center="{latitude: city.coords ? city.coords.latitude : 0, longitude: city.coords ? city.coords.longitude : 0}"
                    :city="city"
                    :contract="contract"
                    :sector="sector"
                    :section="section"
                    ref="picker"
                />
            </div>
            <div class="districts-list-ul" :class="map_enable ? 'col-3 p-0' : ''">
                <div class="districts-list-es">
                    <h2>Barrio</h2> 
                    <span @click="hideDistricts">
                        <masked-image class="close-map" src="/img/icons/close.svg"></masked-image>
                    </span>
                </div>

                <div>
                    <ul>
                        <li>
                            <div class="form-check checkbox-city">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="checkbox-city-input"
                                    v-model="check_city"
                                    @input="searchInCity"
                                >

                                <label class="form-check-label" for="checkbox-city-input">
                                    {{ cityName() }} ({{ trans('labels.whole_city') }})
                                </label>
                            </div>
                        </li>
                        <li v-for="district in districts_data" :key="districtId(district)">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="'checkbox-district-' + districtId(district)"
                                    v-model="selected_districts"
                                    :value="districtId(district)"
                                    @change="changedDistrictByInput"
                                >

                                <label class="form-check-label" :class="(districtId(district) == highligh_from_map) ? 'highlight' : ''"
                                    :ref="'checkbox-district-' + districtId(district)"
                                    :for="'checkbox-district-' + districtId(district)"
                                    @mouseover="districtHighlightOn(districtId(district))"
                                    @mouseleave="districtHighlightOff(districtId(district))"
                                >
                                    {{ districtName(district) }} <span v-if="config.districts_count">({{ district.total }})</span>
                                </label>

                                <template v-if="district.quarters && district.quarters.length > 0">
                                    <span v-if="expanded_district.includes(districtId(district))" class="expand-quarters" @click.stop="expandQuarters(districtId(district))"><i class="arrow up"></i></span>
                                    <span v-else class="expand-quarters" @click.stop="expandQuarters(districtId(district))"><i class="arrow down"></i></span>
                                </template>

                                <ul class="list-quarters" v-if="expanded_district.includes(districtId(district)) && district.quarters && district.quarters.length > 0">
                                    <li v-for="quarter in district.quarters" :key="districtId(quarter)">
                                        <div class="form-check">
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :id="'checkbox-quarter-' + districtId(quarter)"
                                                v-model="selected_quarters"
                                                :value="districtId(quarter)"
                                                @change="changedQuarter"
                                            >

                                            <label class="form-check-label"
                                                :class="(districtId(district) == highligh_from_map) ? 'highlight' : ''"
                                                :ref="'checkbox-quarter-' + districtId(quarter)"
                                                :for="'checkbox-quarter-' + districtId(quarter)"
                                                @mouseover="districtHighlightOn(districtId(district))"
                                                @mouseleave="districtHighlightOff(districtId(district))"
                                            >
                                                {{ districtName(quarter) }} <span v-if="config.districts_count">({{ quarter.total }})</span>
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>

                    <div class="close-button"></div>

                    <div class="search-button">
                        <button
                            class="btn btn-network btn-sm float-right"
                            :disabled="!searchDisable"
                            @click.prevent="searchDistricts">
                            {{ lang.labels.search }}
                        </button>
                        <button
                            class="btn btn-network btn-sm undo float-left"
                            @click.prevent="hideDistricts"
                        >
                            {{ lang.labels.cancel }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from './Modal'
import TecnoMapPicker from './maps/Picker'

export default {
    components: {
        'modal': Modal,
        'tecno-map-picker': TecnoMapPicker
    },

    props: {
        city: {
            type: Object,
            required: true,
        },

        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        contract: {
            type: String,
            required: false,
        },

        districts: {
            type: Array,
            required: false,
        },

        is_home: {
            type: Boolean,
            default: false,
        },

        searchData: {
            type: Object,
            required: false,
        },

        section: {
            type: String,
            required: false,
        },

        sector: {
            type: String,
            required: false,
        }
    },

    data() {
        return {
            check_city: false,
            districts_data: this.districts ?? [],
            placeholder: '',
            selected_districts: [],
            selected_quarters: [],
            highligh_from_map: null,
            expanded_district: [],
            map_enable: this.config.districts_map && this.is_home ? true : false
        }
    },

    computed: {
        lang() {
            return this.$root.lang.search_bar
        },

        searchDisable() {
            if (this.check_city || this.selected_districts.length || this.selected_quarters.length) {
                return true
            }

            return false
        }
    },

    watch: {
        city() {
            this.loadDistricts()
        }
    },

    mounted() {
        // window.events.$on('list.districts_list', districts => {
        //     this.districts_data = districts
        // })

        window.events.$on('search_by_districts', districts => {
            if (districts.id) {
                this.selected_districts = districts.id.split('|').map(el => {
                    let n = Number(el)
                    return n === 0 ? n : n || el
                })
            }

            if (districts.quarters_id) {
                this.selected_quarters = districts.quarters_id.split('|').map(el => {
                    let n = Number(el)
                    return n === 0 ? n : n || el
                })
            }
        })

        if (!this.districts_data.length) {
            this.loadDistricts()
        }

        this.loadSelectedDistricts()

        if (this.is_home == false && !this.selected_districts.length && !this.selected_quarters.length) {
            this.check_city = true
        }
    },

    methods: {
        cityName() {
            if (this.city == undefined) {
                return null
            }

            let city = this.city.name ? this.city.name : this.city.city_title

            return city.charAt(0).toUpperCase() + city.slice(1)
        },

        districtId(district) {
            return district.district_id ? district.district_id : district.id
        },

        districtName(district) {
            return district.district_title ? district.district_title : district.title
        },

        getSelectedDistrict() {
            for (const [key, element] of Object.entries(this.districts_data)) {
                if ((element.district_id == this.selected_districts[0]) || (element.id == this.selected_districts[0])) {
                    console.log('element', element)
                    return element
                }
            }

            return this.districts_data.find(district => ( district.district_id == this.selected_districts[0] ))
        },

        hideDistricts() {
            if (this.$root.is_mobile) {
                window.events.$emit('hideModal', { name: 'districts_list_modal' })
            } else {
                this.$emit('hide-districts')
            }
            window.events.$emit('districts-have-been-hidden')

        },

        loadDistricts() {
            this.districts_data = []
            this.selected_districts = []

            if (this.city) {
                axios.get('/api/districts/' + (this.city.id ? this.city.id : this.city.city_id))
                    .then(({data}) => {
                        this.districts_data = data
                    })
            }
        },

        loadSelectedDistricts() {
            if (
                ! this.searchData
                || ! this.searchData.districts
                || typeof this.searchData.districts === 'undefined'
            ) {
                return []
            }

            this.selected_districts = this.searchData.districts.toString().split('|').map(district => {
                return parseInt(district)
            })

            if (
                ! this.searchData
                || ! this.searchData.quarters
                || typeof this.searchData.quarters === 'undefined'
            ) {
                return []
            }

            this.selected_quarters = this.searchData.quarters.toString().split('|').map(district => {
                return parseInt(district)
            })
        },

        searchDistricts() {
            // this.updatePlaceholder()

            window.events.$emit('list.unlock.polygons')

            let data = {
                id: !this.check_city ? this.selected_districts.join('|') : null,
                city_id: this.city.city_id ?? this.city.id,
                quarters_id: !this.check_city ? this.cleanedQuarters().join('|') : null,
            }

            window.events.$emit('search_by_districts', data)
            
            if (this.is_home) {
                isLoading()
            } else {
                setTimeout(() => this.hideDistricts(), 100)
            }

            window.events.$emit('list.districts.all', this.districts_data)
        },

        searchInCity(event) {        
            if (event.target.checked == true) {
                this.districts_data.forEach(district => {
                    this.selected_districts.push(this.districtId(district))

                    if (district.quarters) {
                        district.quarters.forEach(quarter => {
                            this.selected_quarters.push(quarter.id)
                        })
                    }
                })
            } else {
                this.selected_districts = []
                this.selected_quarters = []
            }
        },

        updatePlaceholder() {
            this.placeholder = this.cityName() + ' (' + this.city.province_id + ')'

            console.log(this.selected_districts.length, this.districts_data.length)
            if (this.selected_districts.length === 1) {
                let district = this.getSelectedDistrict()
                this.placeholder +=  ' - ' + this.districtName(district)
            }
            else if (this.selected_districts.length != 0) {
                this.placeholder += ' - ' + this.selected_districts.length + ' ' + this.trans('labels.districts')
            }

            window.events.$emit('update-search-placeholder', this.placeholder)
        },

        addDistrict(id) {
            // Logica di fallback. Se clicco un distretto per la prima volta, attivavo tutti tranne quello cliccato - Disattivato; se clicco un distretto, è quello che voglio attivare.
            // if (this.selected_districts.length == 0)
            // {
            //     this.selected_districts = this.districts_data.map(item => item.district_id).filter(item => item !== id)

            //     this.selected_districts.forEach(district_id => {
            //         let district = this.districts_data.find(item => this.districtId(item) == district_id)
            //         if (district.quarters && district.quarters.length > 0)
            //         {
            //             district.quarters.forEach(quarter => {
            //                 this.selected_quarters.push(this.districtId(quarter))
            //             })
            //         }
            //     })
            // }
            // else
            // {
                this.selected_districts.push(id)
                let district = this.districts_data.find(item => this.districtId(item) == id)
                if (district.quarters && district.quarters.length > 0) {
                    district.quarters.forEach(quarter => {
                        this.selected_quarters.push(this.districtId(quarter))
                    })
                }
            // }
        },

        removeDistrict(id) {
            this.selected_districts = this.selected_districts.filter(item => item !== id)

            let district = this.districts_data.find(item => this.districtId(item) == id)
            if (district.quarters && district.quarters.length > 0) {
                district.quarters.forEach(quarter => {
                    this.selected_quarters = this.selected_quarters.filter(item => item !== this.districtId(quarter))
                })
            }
        },

        districtHighlightOn(id) {
            if (this.map_enable) {
                this.$refs.picker.highlightOn(id)
            }
        },

        districtHighlightOff(id) {
            if (this.map_enable) {
                this.$refs.picker.highlightOff(id)
            }
        },

        listHighlightOn(id) {
            this.highligh_from_map = id
            this.$refs['checkbox-district-' + id][0].scrollIntoView({ behavior: 'smooth', block: 'center' })
        },

        listHighlightOff() {
            this.highligh_from_map = null
        },

        expandQuarters(id) {
            if (this.expanded_district.includes(id)) {
                this.expanded_district = this.expanded_district.filter(item => item !== id)
            } else {
                this.expanded_district.push(id)
            }
        },

        changedDistrictByInput(event) {
            console.log('changedDistrictByInput', event.target, event.target.checked, event.target.value)

            this.check_city = false

            let district = this.districts_data.find(item => this.districtId(item) == event.target.value)
            if (district.quarters && district.quarters.length > 0) {
                district.quarters.forEach(quarter => {
                    if (event.target.checked) {
                        this.selected_quarters.push(this.districtId(quarter))
                    } else {
                        this.selected_quarters = this.selected_quarters.filter(item => item !== this.districtId(quarter))
                    }
                })
            }
        },

        changedQuarter(event) {
            this.check_city = false

            let district = this.districts_data.find(item => (item.quarters.find(subitem => this.districtId(subitem) == event.target.value)))

            if (event.target.checked) {
                if (!this.selected_districts.includes(this.districtId(district))) {
                    this.selected_districts.push(this.districtId(district))
                }
            } else {
                let district_selected_quarters = this.selected_quarters.filter(item => district.quarters.map(item => this.districtId(item)).includes(item))

                if (district_selected_quarters.length == 0) {
                    this.selected_districts = this.selected_districts.filter(item => item !== this.districtId(district))
                }
            }
        },

        cleanedQuarters() {
            let final_quarters = []
            
            if (this.selected_quarters) {
                this.selected_quarters.forEach(quarter => {
                    let district = this.districts_data.find(item => (item.quarters.find(subitem => this.districtId(subitem) == quarter)))

                    if (district) {
                        let district_quarters = district.quarters.map(item => this.districtId(item))

                        if (district_quarters.every(i => this.selected_quarters.includes(i)) == false) {
                            final_quarters.push(quarter)
                        }
                    }
                })
            }

            return final_quarters
        }
    },
}
</script>
